import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import BlockedIpRow from './BlockedIpRow';

const HEADERS = [
  { label: 'IP', align: 'left' },
  { label: 'Tipo', align: 'left' },
  { label: 'Endpoint', align: 'left' },
  { label: 'Tentativas', align: 'center' },
  { label: 'Última tentativa', align: 'left' },
  { label: 'Bloqueado até', align: 'left' },
  { label: 'Situação', align: 'left' },
  { label: 'Ações', align: 'right' },
];

/**
 * BlockedIpsTable - Tabela de IPs bloqueados / com histórico de rate limit (Admin Geral > Segurança)
 * @param {Object} props
 * @param {Array} props.blockedIps
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Function} props.onUnblock
 */
function BlockedIpsTable({ blockedIps = [], isLoading = false, error = null, onUnblock }) {
  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : blockedIps.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhum IP bloqueado no momento
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              blockedIps.map((entry) => (
                <BlockedIpRow key={entry.file || `${entry.ip}-${entry.kind}-${entry.endpoint}`} entry={entry} onUnblock={onUnblock} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default BlockedIpsTable;
